import { render, staticRenderFns } from "./CreateTariff.vue?vue&type=template&id=44d706bb&scoped=true"
import script from "./CreateTariff.vue?vue&type=script&lang=js"
export * from "./CreateTariff.vue?vue&type=script&lang=js"
import style0 from "./CreateTariff.vue?vue&type=style&index=0&id=44d706bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d706bb",
  null
  
)

export default component.exports